const noneOption = {
    value: 'none',
    label: 'None',
};
export const addNoneOption = (ChildPickListDictionary, primarySelected, isRequired) => {
    const options = ChildPickListDictionary[primarySelected]?.pickListItems?.map((option) => ({
        label: option,
        value: option,
    }));
    if (!options)
        return [];
    return isRequired ? options : [noneOption, ...options];
};
